// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"WorkExperienceTooltip-module--tableCell--LNuCV"};